import React, { useState, useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { toTitleCase } from '../../../../lib/utils'
import { uploadPhoto } from '../../../../services/udapi/photos'
import Alert from '../../../Modals/Alert'
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle'
import Button from '../../../Button'
import Check from '../../../../assets/svg/Feather/Check'
import ghAnalytics from '../../../../lib/analytics'
import Loader from '../../../Loader'
import Panel from '../../Panel'
import Photo from './Photo'
import PhotoViewer from '../../../Modals/PhotoViewer'
import styles from './Photos.module.scss'

export const Photos = (props) => {
	const isOwner = props.selectedFeature.isOwner
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		props.dispatch({
			type: 'features/loadPhotosDataEffect',
			callback: () => {
				setIsLoading(false)
			},
		})
	}, [props.selectedFeature.uuid])

	// The dispatches below are not in an actions file due
	// to wanting to keep the dispatch in the useEffect above.
	const openFileExplorer = () => {
		document.getElementById('addPhoto').click()
	}

	const processPhoto = (files) => {
		for (let i = 0; i < files.length; i++) {
			const file = files[i]
			props.dispatch({
				type: 'features/getNewPhotoIdEffect',
				payload: file.name,
				callback: (photoId) => {
					const reader = new FileReader()
					reader.onload = () => {
						storePhoto(file, photoId, props.selectedFeature)
						// Clean up FileReader after use
						reader.onload = null
						reader.onerror = null
						reader.onabort = null
					}
					reader.onerror = () => {
						console.error('FileReader error')
						reader.onload = null
						reader.onerror = null
						reader.onabort = null
					}
					reader.readAsDataURL(file)
				},
			})
		}
	}

	const storePhoto = (file, photoId, feature) => {
		props.dispatch({
			type: 'toast/show',
			payload: {
				text: 'Uploading photo...',
				loader: true,
				dismissable: true,
			},
		})

		props.dispatch({
			type: 'features/setIsUploadingPhoto',
			payload: true,
		})

		uploadPhoto(file, feature.uuid, photoId)
			.then((result) => {
				if (result.success) {
					props.dispatch({
						type: 'features/getPhotoPoll-start',
						payload: photoId,
						callback: (response) => {
							if (response) {
								props.dispatch({
									type: 'features/getPhotoPoll-stop',
								})

								props.dispatch({
									type: 'features/addPhotoToSelectedFeature',
									payload: response.data,
								})

								props.dispatch({
									type: 'features/setIsUploadingPhoto',
									payload: false,
								})

								props.dispatch({
									type: 'toast/show',
									payload: {
										text: 'Photo uploaded',
										icon: Check,
										iconColor: '#F37735',
									},
								})

								setTimeout(() => {
									props.dispatch({
										type: 'toast/dismiss',
									})
								}, 3500)

								ghAnalytics.logUploadPhoto(photoId)
							} else {
								props.dispatch({
									type: 'toast/show',
									payload: {
										dismissable: true,
										icon: AlertCircle,
										iconColor: '#FF3B30',
										text: 'There was an error retrieving your photo.',
									},
								})

								props.dispatch({
									type: 'features/setIsUploadingPhoto',
									payload: false,
								})
							}
						},
					})
				} else {
					props.dispatch({
						type: 'toast/show',
						payload: {
							dismissable: true,
							icon: AlertCircle,
							iconColor: '#FF3B30',
							text: 'There was an error uploading your photo.',
						},
					})

					props.dispatch({
						type: 'features/setIsUploadingPhoto',
						payload: false,
					})
				}
			})
			.catch((err) => {
				props.dispatch({
					type: 'toast/show',
					payload: {
						dismissable: true,
						icon: AlertCircle,
						iconColor: '#FF3B30',
						text: 'There was an error uploading your photo.',
					},
				})

				props.dispatch({
					type: 'features/setIsUploadingPhoto',
					payload: false,
				})
			})
	}

	const selectPhoto = (photo) => {
		props.dispatch({
			type: 'modals/add',
			payload: {
				props: {
					feature: props.selectedFeature,
					photo,
					closePhotoViewer: () => {
						props.dispatch({ type: 'modals/close' })
					},
					deletePhoto: () => {
						props.dispatch({
							type: 'modals/close',
						})
						props.dispatch({
							type: 'modals/add',
							payload: {
								component: Alert,
								props: {
									title: 'Delete photo',
									subtitle: 'Are you ure you want to delete this photo? It will be removed from Maps on all of your devices.',
									actionItems: [
										{
											title: 'Delete',
											onClick: () => {
												props.dispatch({
													type: 'features/deletePhotoEffect',
													payload: photo.uuid,
													callback: (response, error) => {
														if (response) {
															props.dispatch({
																type: 'modals/close',
															})
															props.dispatch({
																type: 'toast/show',
																payload: {
																	text: 'Photo deleted',
																	icon: Check,
																	iconColor: '#F37735',
																},
															})
															setTimeout(() => {
																props.dispatch({
																	type: 'toast/dismiss',
																})
															}, 3500)
														} else {
															props.dispatch({
																type: 'modals/close',
															})
															props.dispatch({
																type: 'toast/show',
																payload: {
																	dismissable: true,
																	icon: AlertCircle,
																	iconColor: '#FF3B30',
																	text: 'There was an error deleting your photo.',
																},
															})
														}										
													},
												})
											},
										},
										{
											title: 'Cancel',
											theme: Button.THEME.solidSecondary,
											onClick: () => {
												props.dispatch({
													type: 'modals/close',
												})
												selectPhoto(photo)
											},
										},
									],
								},
							},
						})
					},
				},
				component: PhotoViewer,
			},
		})
	}

	return (
		<Panel
			title={'Photos'}
			count={props.selectedFeature.photoIds.length}
			collapsible={true}
			actions={
				isOwner
					? [
						{
							name: '+Add',
							disabled: props.isUploadingPhoto,
							onClick: () => {
								openFileExplorer()
							},
						},
					]
					: []
			}>
			{isLoading || props.isUploadingPhoto ? (
				<div className={styles.loaderContainer}>
					<Loader active={isLoading || props.isUploadingPhoto} />
				</div>
			) : null}
			{props.selectedFeature.photos && props.selectedFeature.photos.length > 0 && !isLoading && (
				<div>
					<input id='addPhoto' type='file' accept='image/png, image/jpeg, image/jpg' onChange={(e) => processPhoto(e.target.files)} hidden />
					<div className={styles.photosList}>
						{props.selectedFeature.photos.map((photo, i) => {
							return (
								<div className={styles.photoContainer} onClick={() => selectPhoto(photo)} key={`${photo.uuid}-${i}`}>
									<Photo photo={photo} />
								</div>
							)
						})}
					</div>
				</div>
			)}
		</Panel>
	)
}

Photos.propTypes = {
	isUploadingPhoto: PropTypes.bool,
	selectedFeature: PropTypes.object,
}

export default connect((model) => {
	const { isUploadingPhoto, selectedFeature } = model.features
	if (selectedFeature.photos && selectedFeature.photos.length) {
		let photo = null
		for (let pi = 0; pi < selectedFeature.photos.length; pi++) {
			photo = selectedFeature.photos[pi]
			photo.title = toTitleCase(photo.title.replace(/\.[^/.]+$/, ''))
		} 
	}
	return {
		isUploadingPhoto,
		selectedFeature,
	}
})(Photos)
